import React, { Component , Fragment} from 'react';
import { connect } from 'react-redux';
import { Route, withRouter } from 'react-router-dom';
import oitsActionCreators from '../../store/oits/action-creators/index';
import LoadingOverlay from '../../../shared/components/LoadingOverlay';
import OitDetail from './OitDetail';
import OitIndex from './OitIndex';

class MyOitContainer extends Component {
  // ----------------------
  // Lifecycle
  // ----------------------

  componentDidMount() {
    this.props.loadOitsContainer(this.props.userContext.scope);
  }


  componentWillUnmount() {
    this.props.unmountOitsContainer();
  }

  render() {
    return (
      <LoadingOverlay isLoading={this.props.isLoading}>
        <div>
          <Route component={OitIndex} exact path="/my-oits"/>
          <Route component={OitDetail} path="/oits/:oitGuid"/>
        </div>
      </LoadingOverlay>
    );
  }
}

// ----------------------
// Redux Mappings
// ----------------------

const mapStateToProps = (state) => {
  return {
    isLoading: state.oits.isLoading.length > 0,
    userContext: state.common.userContext
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    loadOitsContainer: (scope) => {
      return dispatch(oitsActionCreators.loadOitsContainer(scope));
    },
    unmountOitsContainer: () => {
      return dispatch(oitsActionCreators.unmountOitsContainer());
    },
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MyOitContainer));
